import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import SkipToMapLinkContainer from '../SkipToMapLink/SkipToMapLinkContainer.js';
import LocationSearchList from '../LocationSearchList/LocationSearchList.js';

const LocationSearchListLayout = (_param)=> {
    var { className , loadingListItems , listItems , topContent , searchForm , showTabs , infoContent , showLinkToMap , googleMapsId , highlightPreferredStore  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "loadingListItems",
        "listItems",
        "topContent",
        "searchForm",
        "showTabs",
        "infoContent",
        "showLinkToMap",
        "googleMapsId",
        "highlightPreferredStore"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('location-search-list-layout', className)
    }), topContent, /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('location-search-list-layout__search-form', {
            'location-search-list-layout__search-form--hidden': showTabs
        })
    }, searchForm, showLinkToMap && googleMapsId && /*#__PURE__*/ React__default.createElement(SkipToMapLinkContainer, {
        mapId: googleMapsId
    })), highlightPreferredStore, infoContent, /*#__PURE__*/ React__default.createElement(LocationSearchList, {
        loading: loadingListItems
    }, listItems));
};
var LocationSearchListLayout$1 = LocationSearchListLayout;

export { LocationSearchListLayout$1 as default };
//# sourceMappingURL=LocationSearchListLayout.js.map
